import React from 'react';
import { TabsOrentations } from '../MTabs.model';

import classes from './MTabsNavItem.module.scss';
import classNames from 'classnames';

type Props<Tabs extends string> = {
  id: Tabs;
  active?: boolean;
  classNameItem?: string;
  classNameSelected?: string;
  orientation?: TabsOrentations;
  onTabClick: (id: Tabs) => void;
};

const MTabsNavItemView = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  const activeStyle = `${
    props.orientation === TabsOrentations.Vertical
      ? classNames(classes['content--active--vertical'], props.classNameItem)
      : classes['content--active']
  } ${props.classNameSelected}`;

  return (
    <div
      className={classNames(
        `${classes['content']} ${props.active ? activeStyle : classNames(classes['content--inactive'], props.classNameItem)}`,
        {
          [classes['hide']]: !props.children,
        },
      )}
      onClick={() => props.onTabClick(props.id)}
    >
      {props.children}
    </div>
  );
};

MTabsNavItemView.displayName = 'MTabsNavItemView';

export default MTabsNavItemView;
